import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import APIServicenew from "../utils/APIGeneralService";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { getCookies, setCookies } from "../utils/Helper";
import { UserContext } from "../context/UserContextProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

const Login = () => {
  const navigate = useNavigate();
  const { setAccessToken } = useContext(UserContext);

  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [load, setLoad] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const headers = { "auth-token": authToken };

  useEffect(() => {
    const savedEmail = getCookies("savedEmail");
    const savedPassword = getCookies("savedPassword");
    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(String(savedPassword));
      setRememberMe(true);
    }
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!email) newErrors.email = "Email is required.";
    else if (!/^\S+@\S+\.\S+$/.test(email))
      newErrors.email = "Enter a valid email address.";

    if (!password) newErrors.password = "Password is required.";
    else if (password.length < 6) newErrors.password = "Password must be at least 6 characters.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoad(true);
    try {
      const res = await APIServices.post(
        "admin/login",
        { email, password },
        headers
      );

      if (res?.data?.status === true) {
        const accessToken = res.data.data.access_token;
        setCookies("accessToken", accessToken);
        setAccessToken(accessToken);

        if (rememberMe) {
          setCookies("savedEmail", email, 30);
          setCookies("savedPassword", password, 30);
        } else {
          setCookies("savedEmail", "", -1);
          setCookies("savedPassword", "", -1);
        }

        showToast(res.data.message || "Login successful", "success");
        setTimeout(() => navigate("/admin/dashboard"), 2000);
      } else {
        showToast(res?.data?.message || "Login failed", "error");
      }
    } catch (err) {
      showToast("Something went wrong", "error");
    } finally {
      setLoad(false);
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
    });
  };

  return (
    <div className="wrapper">
      <section className="signin-page">
        <Container fluid className="p-0">
          <div className="signin_inner">
            <Row className="align-items-center gx-0">

              {/* LEFT IMAGE */}
              <Col md={12} lg={6}>
                <div className="signin-left">
                  <img
                    src="/images/login_bg.png"
                    className="img-fluid login_bg"
                    alt="login_bg"
                  />
                </div>
              </Col>

              {/* RIGHT FORM */}
              <Col md={12} lg={6}>
                <div className="signin-right w-100 p-4">

                  {/* Logo and Title */}
                  <div className="logo mb-4">
                    <img src="/images/logo.png" className="img-fluid mb-4" alt="logo" />
                    <h2 className="font_24 clr_blue font-600 mb-2">Log in</h2>
                    <p className="clr_grey font_14 font-400">
                      Welcome back! Please enter your details.
                    </p>
                  </div>

                  <Form onSubmit={handleSubmit} noValidate>

                    {/* EMAIL */}
                    <Form.Group className="form-floating mb-4">
                      <Form.Control
                        type="email"
                        className="form-control"
                        id="emailInput"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        isInvalid={!!errors.email}
                      />
                      <Form.Label htmlFor="emailInput">Email *</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>

                    {/* PASSWORD */}
                    <Form.Group className="form-floating position-relative mb-4">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="passwordInput"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        isInvalid={!!errors.password}
                      />
                      <Form.Label htmlFor="passwordInput">Password *</Form.Label>

                      <span
                        className="position-absolute top-50 end-0 translate-middle-y pe-3"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(prev => !prev)}
                      >
                        {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                      </span>

                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </Form.Group>

                    {/* FORGOT PASSWORD */}
                    <div className="text-end mb-4">
                      <Link to="/forgot-password" className="clr_black font_14 font-500">
                        Forgot password?
                      </Link>
                    </div>

                    {/* LOGIN BUTTON */}
                    <Button type="submit" className="btn sky_theme w-100 py-2" disabled={load}>
                      {load ? "Processing..." : "Log In"}
                    </Button>
                  </Form>

                </div>
              </Col>

            </Row>
          </div>
        </Container>
      </section>

      <ToastContainer />
    </div>
  );
};

export default Login;
